// extracted by mini-css-extract-plugin
export var columnList = "_da-0";